import React from "react";
import Buttons from "../button/Buttons";
import SearchBar from "../../../features/component/SearchBar";

function CardSection({
  children,
  cardTitle,
  rightButton,
  buttonClassName,
  titleButtonClick,
  buttonText,
  searchInput,
  searchInputName,
  textWithIcon,
  iconImg,
  handleChange,
  isButtonVisible,
  // --- NEW (minimal) ---
  rightButtons = null,
}) {
  return (
    <div
      className={`card-section ${cardTitle ? "card-section-left" : ""}${
        searchInput && rightButton ? "card-section-between" : ""
      }${rightButton ? "card-button-only" : ""}`}
    >
      {(cardTitle || rightButton) && (
        <div className="card-top-title-btn">
          {cardTitle && <div className="section-title">{cardTitle}</div>}

          {searchInput && (
            <div className="search-input">
              <SearchBar
                searchText={searchInputName}
                handleChange={handleChange}
              />
            </div>
          )}

          {
            isButtonVisible && (

              /* Render the btn-right-sec when either legacy rightButton or new rightButtons exists */
              (rightButton || rightButtons) && (
                <div className="btn-right-sec">
                  {/* Legacy single button (unchanged) */}
                  {rightButton && (
                    <Buttons
                      buttonTypeClassName={buttonClassName}
                      onClick={titleButtonClick}
                      buttonText={buttonText}
                      textWithIcon={textWithIcon}
                      imagePath={iconImg}
                    />
                  )}

                  {/* NEW: render any custom buttons passed from parent (ReactNode) */}
                  {rightButtons && rightButtons}
                </div>
              )
            )
          }
        </div>
      )}
      <div className="card-body-sec mt-3">{children}</div>
    </div>
  );
}

export default CardSection;
